import Vue from "vue";
import ThemeHeroVideo from "./ThemeHeroVideo.vue";
import ThemeFootballEffects from "./ThemeFootballEffects.vue";

const CHRISTMAS_VIDEO = require("@/assets/mikmic/christmas.mp4");
const assets = {
  logo: require("@/assets/mikmic/mikmic-1.png"),
  christmasLogo: require("@/assets/mikmic/mikmic-1-christmas.png"),
  footballLogo: require("@/assets/mikmic/mikmic-1-football.png"),
  footballHeroBackground: require("@/assets/mikmic/football-hero-bg.png"),
  storeImage: require("@/assets/mikmic/mikmic_store_image.png"),
  googleStore: require("@/assets/mikmic/google-store.png"),
  appleStore: require("@/assets/mikmic/apple-store.png"),
  mexicoFlag: require("@/assets/countries/mexico.png"),
  operationMapMexico: require("@/assets/mikmic/MXN_1.png"),
  operationMapGdl: require("@/assets/mikmic/GDL_1.png"),
  operationMapPv: require("@/assets/mikmic/PV_1.png"),
  operationMapChihuahua: require("@/assets/mikmic/CHIHUAHUA_1.png"),
  featureAmountService: require("@/assets/mikmic/amount_service.jpeg"),
  featureChat: require("@/assets/mikmic/chat.jpeg"),
  featureRouteService: require("@/assets/mikmic/route_service.jpeg"),
  featureProfile: require("@/assets/mikmic/profile.png"),
  featureRoute: require("@/assets/mikmic/route.png"),
  featureReputation: require("@/assets/mikmic/reputation.png"),
  featureTravel: require("@/assets/mikmic/travel.png"),
  featureHistory: require("@/assets/mikmic/history.png"),
  christmasHeroVideo: CHRISTMAS_VIDEO,
};

export const themes = {
  base: {
    id: "base",
    className: "theme-base",
    effects: {
      snow: false,
    },
    assets: {
      logo: assets.logo,
      heroLogo: assets.logo,
      storeImage: assets.storeImage,
      googleStore: assets.googleStore,
      appleStore: assets.appleStore,
      mexicoFlag: assets.mexicoFlag,
      operationMapMexico: assets.operationMapMexico,
      operationMapGdl: assets.operationMapGdl,
      operationMapPv: assets.operationMapPv,
      operationMapChihuahua: assets.operationMapChihuahua,
      featureAmountService: assets.featureAmountService,
      featureChat: assets.featureChat,
      featureRouteService: assets.featureRouteService,
      featureProfile: assets.featureProfile,
      featureRoute: assets.featureRoute,
      featureReputation: assets.featureReputation,
      featureTravel: assets.featureTravel,
      featureHistory: assets.featureHistory,
      heroVideo: null,
    },
  },
  christmas: {
    id: "christmas",
    className: "theme-christmas",
    effects: {
      snow: true,
    },
    assets: {
      logo: assets.christmasLogo,
      heroLogo: assets.christmasLogo,
      heroVideo: assets.christmasHeroVideo,
    },
  },
  football: {
    id: "football",
    className: "theme-football",
    effects: {
      snow: false,
    },
    assets: {
      logo: assets.footballLogo,
      heroLogo: assets.footballLogo,
      heroBackground: assets.footballHeroBackground,
      heroVideo: null,
    },
  },
};

export const themeState = Vue.observable({
  activeTheme: themes.base,
});

function isValidTheme(themeId) {
  return Boolean(themes[themeId]);
}

export function setTheme(themeId) {
  const nextTheme = themes[themeId] || themes.base;

  themeState.activeTheme = nextTheme;
  applyThemeVariables(nextTheme);

  return themeState.activeTheme;
}

export function resetTheme() {
  return setTheme("base");
}

export function getThemeAsset(assetName) {
  const activeAssets = themeState.activeTheme.assets || {};
  const baseAssets = themes.base.assets || {};

  return activeAssets[assetName] || baseAssets[assetName] || null;
}

export function installTheme(VueInstance) {
  VueInstance.component("ThemeHeroVideo", ThemeHeroVideo);
  VueInstance.component("ThemeFootballEffects", ThemeFootballEffects);

  VueInstance.prototype.$themeState = themeState;
  VueInstance.prototype.$themes = themes;
  VueInstance.prototype.$setTheme = setTheme;
  VueInstance.prototype.$resetTheme = resetTheme;
  VueInstance.prototype.$themeAsset = getThemeAsset;

  VueInstance.mixin({
    computed: {
      $activeTheme() {
        return themeState.activeTheme;
      },
    },
  });
}

function applyThemeVariables(theme) {
  if (typeof document === "undefined") {
    return;
  }

  const heroBackground = theme.assets && theme.assets.heroBackground;

  if (heroBackground) {
    document.documentElement.style.setProperty(
      "--theme-hero-background",
      `url("${heroBackground}")`
    );
  } else {
    document.documentElement.style.removeProperty("--theme-hero-background");
  }
}
